import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { throwError } from '../../../modules/error';
import CustomLoading from '../../uiParts/CustomLoading';
import Header from '../../uiParts/Header';
import MetaTitle from '../../utils/MetaTitle';

// Firebase Auth のメール（招待・パスワード再設定）のアクションURL（/action）の振り分け
const Action: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    try {
      const params = new URLSearchParams(window.location.search);
      const mode = params.get('mode');
      const oobCode = params.get('oobCode') ?? '';

      switch (mode) {
        // パスワード再設定: アプリのパスワード変更画面で処理する
        case 'resetPassword':
          navigate(`/auth/password_change?oobCode=${encodeURIComponent(oobCode)}`, {
            replace: true,
          });
          break;
        // スタッフ招待: continueUrl（/staff/register?e=...）に mode と oobCode を付けて遷移する
        case 'signIn': {
          const continueUrl = params.get('continueUrl');
          if (!continueUrl) {
            throw new Error('URLが見つかりません');
          }
          // 別ドメインへ遷移させないよう、パスとクエリだけを使う
          const url = new URL(continueUrl);
          url.searchParams.set('mode', mode);
          url.searchParams.set('oobCode', oobCode);
          navigate(`${url.pathname}${url.search}`, { replace: true });
          break;
        }
        // それ以外（メールアドレス確認など）は Firebase 標準の画面で処理する
        default:
          window.location.replace(`/__/auth/action${window.location.search}`);
      }
    } catch (e) {
      throwError(e);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  return (
    <>
      <MetaTitle />
      <CustomLoading loading={loading} />
      <Header />
    </>
  );
};

export default Action;
